module.exports = __webpack_public_path__ + "img/svmic-logo.a9a752aa.png";